import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CodeInputComponent } from './code-input.component';

@NgModule({
  imports: [CommonModule, CodeInputComponent],
  exports: [CodeInputComponent],
})
export class CodeInputModule {}
